<ng-template #arrowAction>
  <outlaw-icon name="arrowLeft" [size]="20" class="calendar-arrow-icon" />
</ng-template>

<ol-list-widget
  [layoutConfig]="null"
  [title]="title()"
  [headerLink]="headerLink()"
  [widgets]="processedEvents()"
  [disableViewportLogic]="true"
  [headerActionTemplate]="headerLink() ? arrowAction : null"
  class="calendar-events-widget"
>
  <ng-template #itemTemplate let-item>
    <ol-image-widget [widget]="item" />
  </ng-template>
</ol-list-widget>
